import { render, staticRenderFns } from "./CreateCouverture.vue?vue&type=template&id=5a570fed"
import script from "./CreateCouverture.vue?vue&type=script&lang=js"
export * from "./CreateCouverture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports